import type { EntityConfig } from '../types'

export const reconciliationEntity: EntityConfig = {
  name: 'reconciliation',
  displayName: 'Reconciliation Record',
  pluralName: 'Reconciliation',
  status: {
    field: 'status',
    options: [
      { value: 'matched', label: 'Matched', color: 'success' },
      { value: 'unmatched', label: 'Unmatched', color: 'error' },
      { value: 'partial', label: 'Partial', color: 'warning' },
      { value: 'pending_review', label: 'Pending Review', color: 'pending' },
      { value: 'resolved', label: 'Resolved', color: 'info' },
    ],
    filters: [
      { label: 'All', value: 'all' },
      { label: 'Matched', value: 'matched' },
      { label: 'Unmatched', value: 'unmatched' },
      { label: 'Partial', value: 'partial' },
      { label: 'Pending Review', value: 'pending_review' },
      { label: 'Resolved', value: 'resolved' },
    ],
    mappings: {
      all: ['matched', 'unmatched', 'partial', 'pending_review', 'resolved'],
      matched: ['matched'],
      unmatched: ['unmatched'],
      partial: ['partial'],
      pending_review: ['pending_review'],
      resolved: ['resolved'],
    },
  },
  queryFields: {
    status: { field: 'status', type: 'select', label: 'Status' },
    network: { field: 'network', type: 'select', label: 'Network' },
    type: { field: 'type', type: 'select', label: 'Type' },
  },
  uiFilterFields: ['status', 'network', 'type'],
}
